<template>
  <div>
    <layout>
      <div slot="content" class="contentWrap">
        <swiper
          v-if="list.length > 0"
          :options="swiperOption"
          ref="swiperOption"
          class="swiperWrap"
        >
          <swiper-slide
            v-for="(item, index) in list"
            :key="index"
            class="swiperItem"
            @click="Jump(item.id, item.skip_url)"
          >
            <img :src="item.img" @click="Jump(item.id, item.skip_url)" />
            <div class="txt" @click="Jump(item.id, item.skip_url)">
              <p
                class="title"
                data-swiper-parallax="-100"
                data-swiper-parallax-opacity="0"
              >
                {{ item.title }}
              </p>
              <p
                class="subtitle"
                data-swiper-parallax="-300"
                data-swiper-parallax-opacity="0"
              >
                {{ item.subtitle }}
              </p>
            </div>
          </swiper-slide>

          <div class="pagWrap" slot="pagination"></div>
        </swiper>
      </div>
    </layout>
    <div class="loadingbox">
      <img class="loadingbg" src="@/assets/img/loadingbg.jpg" alt="" />
      <img class="loadinglogo" :src="$store.state.v_loge" alt="" v-if="shop_id"/>
      <img class="loadinglogo" src="@/assets/img/loaddinglogo.png" alt="" v-else/>
      <img class="loading" src="@/assets/img/loading.gif" alt="" />
      <p>正在加载内容中请稍等~</p>
    </div>
  </div>
</template>

<script>
import { Progress } from "vant";
import Vue from "vue";
Vue.use(Progress);
import { activeHome, shoppCarList } from "../api/http.js";
import layout from "@/components/layout.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
    getLocalStorage,
    setLocalStorage,
    removeLocalStorage,
} from "@/utils/storage.js";
export default {
  components: {
    layout,
    swiper,
    swiperSlide
  },
  data() {
    return {
      list: [],
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        speed: 1000,
        parallax: true,
        loop: true,
        pagination: {
          el: ".pagWrap",
          clickable: false,
          type: "progressbar",
          progressbarFillClass: "swpagination",
          renderProgressbar: function(progressbarFillClass) {
            return '<span class="' + progressbarFillClass + '" ></span>';
          }
        }
      },
      shop_id: getLocalStorage("shop_id")

    };
  },
  created() {},
  mounted() {
    document.querySelector(".nav_top").style.opacity = 0;
    document.querySelector(".imgName").style.opacity = 0;
    document.querySelectorAll(".van-tabbar-item").forEach(item => {
      item.style.opacity = 0;
    });
    this.activeHome();
  },
  activated() {
    if (localStorage.getItem("login_token")) {
      let token = localStorage.getItem("login_token");
      shoppCarList(token).then(res => {
        this.$store.commit("cart", res.data.goods_list.length);
      });
    } else {
      this.$store.commit("cart", 0);
    }
  },
  methods: {
    activeHome() {
      activeHome(this.shop_id?this.shop_id:'')
        .then(res => {
          let data = res.data.data;
          this.list = [];
          for (let i in data) {
            for (let j in data[i].image) {
              this.list.push({
                id: data[i].pad_ad_id,
                img: data[i].image[j].file_path,
                title: data[i].name,
                subtitle: data[i].subheading,
                skip_url: data[i].skip_url
              });
            }
          }
          this.transition();
        })
        .catch(() => {
          this.transition();
        });
    },
    transition() {
      setTimeout(() => {
        document.querySelector(".loadingbox").style.opacity = 0;
        setTimeout(() => {
          document.querySelector(".loadingbox").style.display = "none";
        }, 300);
        setTimeout(() => {
          document.querySelector(".nav_top").style.opacity = 1;
        }, 500);
        setTimeout(() => {
          document.querySelector(".imgName").style.opacity = 1;
        }, 1000);
        setTimeout(() => {
          let time = 200;
          document.querySelectorAll(".van-tabbar-item").forEach(item => {
            setTimeout(() => {
              item.style.opacity = 1;
            }, time);
            time += 100;
          });
        }, 1500);
      }, 1500);
    },

    Jump(id, url) {
      console.log(1);
      if (url != "") {
        this.$router.push(url);
      } else {
        this.$router.push({
          path: "/videodetail",
          query: {
            id: id
          }
        });
      }
    },
    changeIndex(current, total) {
      console.log(this.progress);
      this.progress = (current / total) * 100;
    }
  }
};
</script>
<style lang="scss" scoped>
.loadingbox {
  transition: 0.5s;
  opacity: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #fff;
  top: 0;
  z-index: 99999;
  .loadinglogo {
    position: absolute;
    top: 43%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
  }
  .loadingbg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .loading {
    width: 30px;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  p {
    font-size: 15px;
    position: absolute;
    top: 63%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.contentWrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  // overflow: hidden;
  height: 100vh;
  .swiperWrap {
    height: 100%;
    // position: fixed;
    .swiperItem {
      position: relative;
      overflow: hidden;
      height: 100%;
      img {
        height: 100%;
        position: relative;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .txt {
        position: absolute;
        bottom: 75px;
        color: #fff;
        width: 100%;
        p {
          width: 100%;
          text-align: center;
          margin: 0px;
        }
        .title {
          margin-bottom: 10px;
          font-size: 36px;
          font-weight: 600;
        }
        .subtitle {
          font-size: 22px;
        }
      }
    }
    .pagWrap {
      // height: 20px;
      background: #d6d6d6;
      height: 5px !important;
      width: 300px !important;
      position: fixed;
      bottom: 50px !important;
      z-index: 10;
      left: 50% !important;
      top: initial !important;
      transform: translateX(-50%);
    }
  }
}
</style>
<style>
.swpagination {
  background: #c9a864;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  transform-origin: left top;
}
</style>
